import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import {
  useDepartmentOptions,
  useEmployee,
  useRoleOptions,
  useUpdateEmployee,
} from "../hooks";
import { EmployeeForm } from "../components/EmployeeForm";
import { PageLoader } from "#/components/common/PageLoader";
import { ErrorState } from "#/components/common/ErrorState";

export default function EmployeeEditPage() {
  const { employeeId } = useParams();
  const navigate = useNavigate();

  const id = Number(employeeId);

  const employeeQuery = useEmployee(id);
  const departmentsQuery = useDepartmentOptions();
  const rolesQuery = useRoleOptions();
  const updateMutation = useUpdateEmployee();

  const loading =
    employeeQuery.isLoading ||
    departmentsQuery.isLoading ||
    rolesQuery.isLoading;

  if (loading) {
    return <PageLoader label="Loading employee form..." />;
  }

  if (!Number.isFinite(id) || employeeQuery.error || !employeeQuery.data) {
    return <ErrorState message="Failed to load employee details." />;
  }

  return (
    <div className="space-y-6">
      <div>
        <Link
          to={`/employees/${id}`}
          className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to employee
        </Link>

        <h1 className="mt-3 text-2xl font-bold text-slate-900">
          Edit employee
        </h1>
      </div>

      <EmployeeForm
        employee={employeeQuery.data}
        departments={departmentsQuery.data ?? []}
        roles={rolesQuery.data ?? []}
        loading={updateMutation.isPending}
        onSubmit={(values) =>
          updateMutation.mutate(
            { id, payload: values },

            { onSuccess: () => navigate(`/employees/${id}`) },
          )
        }
      />
    </div>
  );
}
